mutation InviteCharityContact($input: InviteCharityContactInput!) {
  inviteCharityContact(input: $input) {
    success
  }
}
